import React, {useEffect, useMemo, useState} from 'react';
import ImageViewer from "../ImageViewer";
import PDFViewer from "../../../../components/ocr-batch/PDFViewer";
import {type OcrFileContentType} from "../../../../models/ocr.models";
import {base64ToBlobUrl} from "../../../../utils/ocr-utils";

interface ScanPanelProps {
    fileName: string;
    contentType: OcrFileContentType;
    baseContent: string;
}

const ScanPanel = ({fileName, contentType, baseContent}: ScanPanelProps) => {
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!baseContent || !contentType) return;

        const mimeType = contentType === 'PDF' ? 'application/pdf' : `image/${contentType.toLowerCase()}`;

        const url = base64ToBlobUrl(baseContent, mimeType);
        setPreviewUrl(url);

        return () => {
            URL.revokeObjectURL(url);
        };
    }, [baseContent, contentType]);

    return (
        <>
            {contentType === 'PDF' ? (
                <PDFViewer previewUrl={previewUrl} fileName={fileName} />
            ) : (
                <ImageViewer previewUrl={previewUrl} fileName={fileName} />
            )}
        </>
    );
};

export default ScanPanel;